// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GAEventsConstants$PorterinFeature from "../../core/constants/GAEventsConstants.mjs";
import * as CommonLeadFlowAnalytics$PorterinFeature from "./CommonLeadFlowAnalytics.mjs";

function successEvent(page, name, mobile, requirement, utm_source, utm_campaign, service_category, city, locale) {
  CommonLeadFlowAnalytics$PorterinFeature.successEvent(page, name, mobile, requirement, utm_source, utm_campaign, service_category, city, locale, GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulTrucks);
}

export {
  successEvent ,
}
/* CommonLeadFlowAnalytics-PorterinFeature Not a pure module */
